module.exports = __webpack_public_path__ + "static/10-4f9a4d0104c85506b70a7429062dfb15.jpg";